import React from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Alert, Form, Button, Row, Col, Panel } from 'react-bootstrap';
import { FormActions, Select, Radio, Static } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const SettingsForm = ({ error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, t, data, lessonDates,
	sourceProgramLessons, attendsInMorePrograms, activePayments, onSourceWeeklyProgramChange, lessonTypes, onLessonTypeChange, change,
	sourceLessonDate, targetLessonDate }) => {

	const toObject = (value, highlight) => {
		return {
			label: <span style={{ fontWeight: highlight ? 'bold' : 'normal' }}>{ui.customDateFormat(value, 'LLLL')}</span>,
			value
		};
	};

	const handleDropdownChange = (onChange, event, value) => {
		change('sourceLessonDate', '');
		if (onChange) {
			onChange(event, value);
		}
	};

	const numberOfLessonsToMove = sourceProgramLessons.filter(lesson => lesson.start >= sourceLessonDate).length;
	const targetLessonDateIndex = lessonDates.findIndex(date => date === targetLessonDate);

	const sourceLessonDates = sourceProgramLessons.map((lesson) => toObject(lesson.start, lesson.start >= sourceLessonDate));
	const targetLessonDates = lessonDates.map((date, index) => toObject(date, date >= targetLessonDate && index < targetLessonDateIndex + numberOfLessonsToMove));

	return (
		<Form onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			{submitSucceeded && pristine && <Alert bsStyle='success'>{t('Common_UpdateSuccess')}</Alert>}

			<Panel>
				<Panel.Body>
					<Row>
						<Col sm={6}>
							<Field name='childFullName' component={Static} label={<b>{t('MoveLessons_Child')}</b>} />
							{attendsInMorePrograms ||
								<Field name='sourceWeeklyProgramFullName' component={Static} label={<b>{t('MoveLessons_SourceWeeklyProgram')}</b>} />
							}
							<Field name='targetWeeklyProgramFullName' component={Static} label={<b>{t('MoveLessons_TargetWeeklyProgram')}</b>} />
						</Col>
						<Col sm={6}>
							<Field name='parentFullName' component={Static} label={<b>{t('MoveLessons_Parent')}</b>} />
						</Col>
					</Row>

				</Panel.Body>
			</Panel>
			<Panel>
				<Panel.Body>
					<Row>
						<Col sm={6}>
							<Select name='lessonType'
								label={<b>{t('MoveLessons_LessonType')}</b>}
								hideEmptyOption={true}
								data={lessonTypes}
								onChange={(event, value) => handleDropdownChange(onLessonTypeChange, event, value)}
								required
								validate={[validators.required]}
							/>
						</Col>
					</Row>
					<Row className={attendsInMorePrograms ? '' : 'invisible'}>
						<Col sm={6}>
							<Select name='sourcePaymentId'
								label={<b>{t('MoveLessons_SourceWeeklyProgram')}</b>}
								data={activePayments}
								emptyLabel={t('Common_PleaseSelect')}
								onChange={(event, value) => handleDropdownChange(onSourceWeeklyProgramChange, event, value)}
								required
								validate={[validators.required]}
							/>
						</Col>
					</Row>
					<Row>
						<Col sm={6}>
							<Field name='sourceLessonDate'
								component={Radio}
								label={<b>{t('MoveLessons_CurrentProgramFinishDate')}</b>}
								entries={sourceLessonDates}
								required
								validate={[validators.required]}
								help={numberOfLessonsToMove > 0 ? t('MoveLessons_LessonDatesHint', { count: numberOfLessonsToMove }) : ''} />
						</Col>
						<Col sm={6}>
							<Field name='targetLessonDate'
								component={Radio}
								label={<b>{t('MoveLessons_NewProgramStartDate')}</b>}
								entries={targetLessonDates}
								required
								validate={[validators.required]} />
						</Col>
					</Row>
					<FormActions>
						<Button type='submit' disabled={submitting} bsStyle='primary' style={{ float: 'right' }}>{t('MoveLessons_MoveLessons')}</Button>
					</FormActions>
				</Panel.Body>
			</Panel>
		</Form>
	);
};

export default reduxForm({ form: 'moveLessonsForm' })(withTranslation()(SettingsForm));

export const selector = formValueSelector('moveLessonsForm');